export default "__VITE_ASSET__0367c12b__"